<template>
   <div id="theme-toggler-container" @click="handlerToggleTheme">
      <UITooltip :tooltip-title="$t('navbarComponent_switchToDarkMode')" tooltip-icon="gts-icon icon-dark-mode icon-sm gts-animation" tooltip-position="bottom" v-if="currentTheme === 'light-theme'">
      </UITooltip>
      <UITooltip :tooltip-title="$t('navbarComponent_switchToLightMode')" tooltip-icon="gts-icon icon-light-mode icon-sm gts-animation" tooltip-position="bottom" v-else> </UITooltip>
   </div>
</template>

<script>
import UITooltip from "@/components/utils/GtsToolTips.vue";
export default {
   name: "ThemeToggler",
   components: {
      UITooltip,
   },
   data() {
      return {
         currentTheme: "light-theme",
      };
   },
   created() {
      const activeTheme = localStorage.getItem("user-theme");
      if (activeTheme == null) {
         localStorage.setItem("user-theme", "light-theme");
         this.currentTheme = "light-theme";
      } else {
         this.currentTheme = activeTheme;
      }
      document.documentElement.className = this.currentTheme;
   },
   methods: {
      handlerToggleTheme() {
         if (this.currentTheme === "light-theme") {
            this.setTheme("dark-theme");
            // window.location.reload();
         } else {
            this.setTheme("light-theme");
            // window.location.reload();
         }
      },
      setTheme(theme) {
         this.currentTheme = theme;
         localStorage.setItem("user-theme", theme);
         document.documentElement.className = theme;
      },
   },
};
</script>

<style scoped>
#theme-toggler-container {
   display: flex;
   align-items: center;
   margin: auto 0.75rem;
   cursor: pointer;
}
</style>
